module.exports = __webpack_public_path__ + "img/operate.ad2cbad3.png";